import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import SendLeadDashboardEmailModalUI from './SendLeadDashboardEmailModalUI'

class SendLeadDashboardEmailModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,

      selectedTemplateCode: '',
      subject: '',
      message: '',
      editText: '',
      toEmails: [], newEmail: '', emailError: null,
      editMode: false,
    }
  }

  render() {
    return (
      <SendLeadDashboardEmailModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        sendEmailMode={this.props.sendEmailMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}

        emailTemplateList={this.props.emailTemplateList}
        selectedTemplateCode={this.state.selectedTemplateCode}
        onTemplateSelect={this.onTemplateSelect}

        subject={this.state.subject}
        message={this.state.editMode ? this.state.editText : this.state.message}
        onMessageChange={(e) => this.setState({ editText: e.target.value })}

        editMode={this.state.editMode}
        onEditClick={() => this.setState({
          editMode: true,
          editText: this.htmlToPlainText(this.state.message)
        })}
        onConfirmEditClick={() => this.setState({
          message: this.plainTextToHtml(this.state.editText),
          editMode: false,
        })}

        toEmails={this.state.toEmails}
        newEmail={this.state.newEmail}
        onNewEmailChange={(e) => this.setState({ newEmail: e.target.value, emailError: null })}
        onAddEmail={this.onAddEmail}
        onRemoveEmail={this.onRemoveEmail}
        emailError={this.state.emailError} />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.entry) return
    if (prevProps.entry && prevProps.entry.leadDashboardId === this.props.entry.leadDashboardId) return

    this.setState({
      toEmails: this.initialEmails(this.props.entry),
      newEmail: '',
      emailError: null,
      selectedTemplateCode: '',
      subject: '',
      message: '',
      editMode: false,
    })
  }

  isValidEmail = (email) => /^[^\d\s@*][^\s@*]*@[^\s@*]+\.[^\s@*]+$/.test(email)
  initialEmails = (entry) => {
    let email = ((entry && entry.email) || '').trim().toLowerCase()
    return email && this.isValidEmail(email) ? [email] : []
  }

  onAddEmail = () => {
    let email = (this.state.newEmail || '').trim().toLowerCase()
    if (!email) return
    if (!this.isValidEmail(email)) {
      this.setState({ emailError: 'Invalid email address' })
      return
    }
    if (this.state.toEmails.includes(email)) {
      this.setState({ emailError: 'Already added' })
      return
    }
    this.setState({ toEmails: [...this.state.toEmails, email], newEmail: '', emailError: null })
  }

  onRemoveEmail = (email) => {
    this.setState({ toEmails: this.state.toEmails.filter(e => e !== email) })
  }

  onTemplateSelect = (event) => {
    let code = event.target.value
    let template = (this.props.emailTemplateList || []).find(t => t.code === code)
    this.setState({
      selectedTemplateCode: code,
      subject: template ? template.subject : '',
      message: template ? this.fillPlaceholders(template.body) : '',
      editText: '',
      editMode: false,
    })
  }
  fillPlaceholders = (body) => {
    let entry = this.props.entry || {}
    let originator = (this.props.originatorList || []).find(o => o.key === entry.originatorUserId)
    let pocFirstName = (entry.poc || '').trim().split(/\s+/)[0]
    let filled = (body || '')
      .split('<POC Name>').join(pocFirstName || '[POC Name]')
      .split('<originator Name>').join(originator ? originator.value : '[originator Name]')
    // markers nobody can fill automatically: make them visible instead of hidden
    let leftovers = ['XXXX', 'XXX', 'Month, Year', 'phone number']
    leftovers.forEach(p => { filled = filled.split('<' + p + '>').join('[' + p + ']') })
    return filled
  }
  htmlToPlainText = (html) => {
    return (html || '').replace(/<br\s*\/?>/gi, '\n')
  }

  plainTextToHtml = (text) => {
    return (text || '').replace(/\n/g, '<br/>')
  }

  onCancelClick = () => {
    this.setState({
      successMsg: null, errorList: null, submitted: false,
      selectedTemplateCode: '', subject: '', message: '', editText: '', editMode: false,
    })
    this.props.onCancelSendEmail()
  }

  onSubmit = () => {
    if (this.state.submitted) return
    if (!this.state.selectedTemplateCode) {
      this.setState({ errorList: ['Please select a template'] })
      return
    }

    // a typed-but-not-added address is included automatically
    let toEmails = this.state.toEmails.slice()
    let pending = (this.state.newEmail || '').trim().toLowerCase()
    if (pending) {
      if (!this.isValidEmail(pending)) {
        this.setState({ emailError: 'Invalid email address' })
        return
      }
      if (!toEmails.includes(pending)) toEmails.push(pending)
    }
    if (toEmails.length === 0) {
      this.setState({ errorList: ['Please add at least one recipient email'] })
      return
    }

    this.setState({ successMsg: null, errorList: [], submitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/leadDashboard/emails/send`,
      this.onSubmitCallback, {
      leadId: this.props.entry ? this.props.entry.leadDashboardId : null,
      toEmails: toEmails,
      subject: this.state.subject,
      message: this.state.editMode ? this.plainTextToHtml(this.state.editText) : this.state.message,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response && response.errorList) {
      response.errorList.forEach(error => { errorList.push(error.message) })
    }

    this.setState({ successMsg: response.success, errorList: errorList, submitted: false })

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        this.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(SendLeadDashboardEmailModalSF)